import {
  Button,
  CloseButton,
  Dialog,
  Portal,
  Text,
} from '@chakra-ui/react';
import { useNavigate, useParams } from 'react-router';
import useStartExecution from '@App/CampaignExecution/hooks/useStartExecution';

type Props = {
  handleClose: () => void;
  afterSubmit: () => void;
};

const ConfirmNextDispositionDialog = ({ handleClose, afterSubmit }: Props) => {
  const navigate = useNavigate();

  const { id } = useParams() as { id: string };

  const { onStartExecution, loading } = useStartExecution({
    executionId: id,
    afterSubmit: () => {
      handleClose()
      afterSubmit()
    },
  });

  const onFinish = () => {
    navigate('/painel/atendimentos', { replace: true });
  };

  return (
    <Dialog.Root
      size="md"
      placement="center"
      open
      onOpenChange={onFinish}
      closeOnInteractOutside={false}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content bg="grayscale.fg">
            <Dialog.Header>
              <Dialog.Title>
                Deseja iniciar um novo atendimento?
              </Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text color="fg.muted">
                Após iniciar o atendimento, é necessário que você finalize-o.
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Button
                variant="outline"
                disabled={loading}
                onClick={onFinish}
              >
                Não
              </Button>
              <Button
                bg="green.700"
                color="white"
                onClick={onStartExecution}
                loading={loading}
              >
                Iniciar
              </Button>
            </Dialog.Footer>

            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};

export default ConfirmNextDispositionDialog;
